import { useMutation } from '@tanstack/react-query'

import { updateFreeeConnectionSettingsForAccounting } from '@src/api'
import { DefaultApiUpdateFreeeConnectionSettingsForAccountingRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useUpdateFreeeConnectionSettingsForAccounting = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (
      params: DefaultApiUpdateFreeeConnectionSettingsForAccountingRequest
    ) => updateFreeeConnectionSettingsForAccounting(axiosInstance, params),
  })
}
